/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled from 'styled-components';

import { Text1 } from 'app/shared/ui';

export const Text1St = styled(Text1)`
  a {
    color: ${({ theme: { colors } }) => colors.mintDark};
    transition: color 200ms ease-in-out;

    &:hover,
    &:focus {
      color: ${({ theme: { colors } }) => colors.heycarMint};
    }
  }
`;
